import axios from 'axios'
import { Modal, message } from 'antd'

const DeleteRecipeIngredient = (props) => {
  const { oid, name } = props.data

  const handleOk = () => {
    axios.post('/admin/user/recipe_ingredient/delete', { 
      recipe_ingredient_oid: oid 
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('删除成功！')
          props.isCancel()
          props.getRecipeIngredientData()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title="删除食材"
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okType='danger'
      okText='删除'>

      <p>正在将食材
        <span style={{color: '#005dff'}}>《{name}》</span>
        从食谱中移除，此操作不可逆，是否确认删除？
      </p>
    </Modal>
  )
}

export default DeleteRecipeIngredient
